import SelectedCustomer from '@/platform/common/components/SelectedCustomer/SelectedCustomer';
import { Header, TabNav, TabNavItem } from '@/platform/ui';
import { Link, usePage } from '@inertiajs/react';

const Navigation = () => {
    const { auth } = usePage().props;
    const { component } = usePage();

    return (
        <>
            <SelectedCustomer />

            <Header as='h2'>SROI</Header>

            <TabNav label='Pagina'>
                {auth?.permissions?.includes('view sroi') && (
                    <TabNavItem
                        as={Link}
                        href={`/customers/${auth?.user?.selected_customer_id}/services/sroi/dashboard`}
                        active={'SROI/DashboardView' === component}
                    >
                        Dashboard
                    </TabNavItem>
                )}
                {auth?.permissions?.includes('view sroi') && (
                    <TabNavItem
                        as={Link}
                        href={`/customers/${auth?.user?.selected_customer_id}/services/sroi/employees`}
                        active={'SROI/CustomerIndexView' === component}
                    >
                        Werknemers
                    </TabNavItem>
                )}
                {auth?.permissions?.includes('edit sroi settings') && (
                    <TabNavItem
                        as={Link}
                        href={`/customers/${auth?.user?.selected_customer_id}/services/sroi/settings/customers`}
                        active={'SROI/CustomerSettingView' === component}
                    >
                        Klant instellingen
                    </TabNavItem>
                )}
                {auth?.permissions?.includes('edit sroi settings') && (
                    <TabNavItem
                        as={Link}
                        href={`/customers/${auth?.user?.selected_customer_id}/services/sroi/settings/entities`}
                        active={'SROI/EntitySettingView' === component}
                    >
                        Entiteiten instellingen
                    </TabNavItem>
                )}
                {auth?.permissions?.includes('update questionnaires') && (
                    <TabNavItem
                        as={Link}
                        href={`/customers/${auth?.user?.selected_customer_id}/services/sroi/settings/questionnaires`}
                        active={'SROI/QuestionnaireSettingsView' === component}
                    >
                        Vragenlijst instellingen
                    </TabNavItem>
                )}
            </TabNav>
        </>
    );
};

export default Navigation;
